export const LEAVES_DEFAULT_QUERY = {
  _pagina: '1',
  _num_x_pagina: '5',
}

export const LEAVES_FILTERS = [
  {
    name: 'provincia',
    comboId: 'bajas_administrativas_provincias',
    size: 'small',
    multiple: false,
  },
  {
    name: 'cod_postal',
    filterType: 'basic-input',
    size: 'small',
  },
]
